import type { GetServerSidePropsContext } from 'next';
import Discharge from '@elem/compPage/efdelta-discharge-information';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import SEOlinksA from '@/components/SEOlinksA';
import { redirectTo404 } from '@/utils';

const whiteLocaleList = ['jp'];

export default function Page({ SEO }: any) {
    const { useRouter, useLang } = useGlobal();
    const router = useRouter();
    const { t } = useLang('discharge');

    return (
        <>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={router.locale} list={whiteLocaleList} pathname={'discharge'} />
            <PageLayout className={`${css.recall} `}>
                <Discharge />
            </PageLayout>
        </>
    );
}

export async function getServerSideProps({ locale }: GetServerSidePropsContext) {
    // 非白名单404
    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
